// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PauseFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M23.398 74.809V21.19c0-2.855 2.129-5.191 4.731-5.191h7.604c2.602 0 4.732 2.336 4.732 5.19V74.81c0 2.855-2.13 5.19-4.732 5.19h-7.604c-2.602 0-4.731-2.335-4.731-5.19ZM60.267 16h7.604c2.602 0 4.731 2.336 4.731 5.191V74.81c0 2.855-2.129 5.191-4.73 5.191h-7.605c-2.6 0-4.732-2.336-4.732-5.19V21.19c0-2.855 2.131-5.19 4.732-5.19Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default PauseFilled;
